class HeaderMegamenu extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const detailsElements = this.querySelectorAll('details');

    detailsElements.forEach(detail => {
      const menuContents = detail.querySelectorAll('.mega-menu__content');
      const maenuContentManinDiv = detail.querySelectorAll('.megamenu-desktop');
      const menuId = detail.getAttribute('data-menu-id');
      const has2menu = detail.getAttribute("data-has_2_menu")

      menuContents.forEach(menuContent => {
        let itemId = menuContent.getAttribute('data-item-id');
        if (itemId && menuId) {
          itemId = itemId.replace(/\s+/g, '').trim();

          if (itemId.includes('-') && !menuId.includes('-') && has2menu == "false") {
            const parts = itemId.split('-');
            itemId = parts[parts.length - 1];
          }

          const parentDiv = menuContent.closest('.megamenu-desktop'); 

          if (itemId !== menuId) {
            menuContent.classList.add('hidden');
            if (parentDiv) parentDiv.classList.add('hidden'); 
            if (parentDiv) parentDiv.classList.remove('matched-menu');
          } else {
            menuContent.classList.remove('hidden');
            if (parentDiv) parentDiv.classList.remove('hidden'); 
            if (parentDiv) parentDiv.classList.add('matched-menu');
          }
        }
      });

      
      const allHidden = Array.from(maenuContentManinDiv).every(div =>
        div.classList.contains('hidden')
      );

      if (allHidden) {
        detail.classList.add('all-hide');
      } else {
        detail.classList.remove('all-hide');
      }

    });
  }
}
customElements.define('header-megamenu', HeaderMegamenu);

let navMegamenuInstanceCount = 0;
class NavMegamenu extends HTMLElement {
  constructor() {
    super();
    this.scrollListener = null;
    this.lastScrollY = 0;
    this.hoverTimeout = null;
    this.activeDetail = null;
    this.animations = new Map(); // Track multiple animations
    // Unique per instance (there can be more than one <nav-megamenu> in the
    // header - e.g. a left menu and a main menu) so window.ScrollLock's
    // holder-counted lock/unlock, shared with the search modal and header
    // drawer, can't have one instance's close release a lock the other
    // instance's still-open panel still needs.
    this.scrollLockId = `nav-megamenu-${++navMegamenuInstanceCount}`;
    this.scrollLocked = false;
    this.init();
    this.showlink();
  }

  showlink() {
    const headerMenuDetails = this.querySelectorAll("header-megamenu details");
    const normalLinks = this.querySelectorAll(".megamenu-normal-link");
    const allMenus = this.querySelectorAll(".megamenu-desktop");

    normalLinks.forEach((normalMenu) => {
      const normalMenuId = normalMenu?.getAttribute("data-normal-menu-id");

      const hasMatch = Array.from(allMenus).some((allmenu) => {
        const itemId = allmenu?.querySelector("div")?.getAttribute("data-item-id");
        return normalMenuId === itemId;
      });

      if (hasMatch) {
        normalMenu.classList.add("hidden");
      } else {
        normalMenu.classList.remove("hidden");
      }
    });

    headerMenuDetails.forEach((detailMenu) => {
      const detailsMenuId = detailMenu?.getAttribute("data-menu-id");
      const hasMatch = Array.from(allMenus).some((allmenu) => {
        const itemId = allmenu?.querySelector("div")?.getAttribute("data-item-id");
        return detailsMenuId === itemId;
      });

      if (!hasMatch) {
        detailMenu.classList.add("hidden");
      } else {
        detailMenu.classList.remove("hidden");
      }
    });
  }

  init() {
    const detailsElements = this.querySelectorAll("details");

    detailsElements.forEach((detail) => {
      detail.addEventListener("mouseenter", () => {
        this.handleMouseEnter(detail, detailsElements);
      });

      detail.addEventListener("mouseleave", () => {
        this.handleMouseLeave(detail);
      });
    });
  }

  handleMouseEnter(detail, detailsElements) {
    // Clear any pending close timeout so quick re-entry cancels the close
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }

    // If already open and active, do nothing
    if (this.activeDetail === detail && detail.hasAttribute("open")) {
      return;
    }

    // Cancel any ongoing animation for this detail
    this.cancelAnimation(detail);

    // Close all other details immediately
    detailsElements.forEach((other) => {
      if (other !== detail && other.hasAttribute("open")) {
        this.cancelAnimation(other);
        this.closeImmediate(other);
      }
    });

    // Open the new detail immediately (no setTimeout)
    this.fadeIn(detail);
  }

  handleMouseLeave(detail) {
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
    }
    this.hoverTimeout = setTimeout(() => {
      if (!detail.matches(":hover")) {
        this.fadeOut(detail);
      }
      this.hoverTimeout = null;
    }, 150); // delay so crossing the gap to the panel doesn't cause flicker
  }

  cancelAnimation(detail) {
    if (this.animations.has(detail)) {
      const anim = this.animations.get(detail);
      anim.cancel();
      this.animations.delete(detail);
    }
  }

  fadeIn(detail) {
    this.activeDetail = detail;
    // iOS-safe scroll lock (position: fixed, not just `overflow: hidden` -
    // see window.ScrollLock in global.js) so the page behind the open
    // megamenu can't be scrolled.
    window.ScrollLock.lock(this.scrollLockId);
    this.scrollLocked = true;

    // media-gallery.js's own wheel handler (the PDP gallery's independent
    // scroll driver) checks this exact class to bail out under any full-page
    // overlay - without it, ScrollLock freezing <body> stops the outer page
    // from scrolling but the gallery keeps hijacking wheel input over itself
    // and scrolls underneath the open megamenu.
    document.body.classList.add('overflow-hidden');
    
    const megaMenu = detail.querySelector(".megamenu-desktop.matched-menu");
    if (!megaMenu) {
      detail.setAttribute("open", "");
      detail.setAttribute("data-animating", "true");
      return;
    }

    // Set initial state
    detail.setAttribute("open", "");
    detail.setAttribute("data-animating", "true");
    megaMenu.style.visibility = "visible";
    megaMenu.style.opacity = "0";

    // Start animation
    const animation = megaMenu.animate(
      { opacity: [0, 1] }, 
      { duration: 300, easing: "ease-out" }
    );

    this.animations.set(detail, animation);

    animation.onfinish = () => {
      megaMenu.style.opacity = "1";
      // Keep data-animating="true" while menu is open
      this.animations.delete(detail);
    };

    animation.oncancel = () => {
      this.animations.delete(detail);
    };
  }

  fadeOut(detail) {
    if (this.activeDetail === detail) {
      this.activeDetail = null;
    }

    if (this.scrollListener) {
      window.removeEventListener("scroll", this.scrollListener);
      this.scrollListener = null;
    }

    const megaMenu = detail.querySelector(".megamenu-desktop.matched-menu");
    if (!megaMenu) {
      this.closeImmediate(detail);
      return;
    }

    detail.setAttribute("data-animating", "true");

    const animation = megaMenu.animate(
      { opacity: [parseFloat(getComputedStyle(megaMenu).opacity) || 1, 0] }, 
      { duration: 200, easing: "ease-in" }
    );

    this.animations.set(detail, animation);

    animation.onfinish = () => {
      this.closeImmediate(detail);
      this.animations.delete(detail);
    };

    animation.oncancel = () => {
      this.animations.delete(detail);
    };
  }

  closeImmediate(detail) {
    const megaMenu = detail.querySelector(".megamenu-desktop.matched-menu");
    if (megaMenu) {
      megaMenu.style.opacity = "0";
      megaMenu.style.visibility = "hidden";
    }
    detail.removeAttribute("open");
    detail.setAttribute("data-animating", "false");
    this.releaseScrollLock();
  }
    releaseScrollLock() {
    if (!this.scrollLocked) return;
    window.ScrollLock.unlock(this.scrollLockId);
    this.scrollLocked = false;
    // Only the last overlay releasing the shared ScrollLock should drop this
    // class - another nav-megamenu instance (or another overlay entirely,
    // e.g. the search modal) may still be holding it.
    if (!window.ScrollLock.isLocked()) {
      document.body.classList.remove('overflow-hidden');
    }
  }
  disconnectedCallback() {
    if (this.scrollListener) {
      window.removeEventListener("scroll", this.scrollListener);
      this.scrollListener = null;
    }

    // if (this.hoverTimeout) {
    //   clearTimeout(this.hoverTimeout);
    //   this.hoverTimeout = null;
    // }

    // Cancel all animations
    this.animations.forEach(anim => anim.cancel());
    this.animations.clear();

    this.activeDetail = null;
    
    // In case a panel was open when this element got removed from the DOM -
    // closeImmediate() never ran, so the lock would otherwise leak.
    this.releaseScrollLock();
  }
}

customElements.define("nav-megamenu", NavMegamenu);
 


class DetailsAnimated extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector(".menu-drawer");
    this.lastlevelMenu = this.querySelector("last-level-detail-menu details");
    this.midLevelMenu = this.querySelectorAll('.mobile-menu-drawer__content');

    this.slideAnimation = null;
    this.isClosing = false;
    this.isExpanding = false;

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200,
    });

    const inner_back_buttons = this.querySelectorAll(".main-back");
    inner_back_buttons.forEach(button => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.closeOtherAccordions();
        this.shrink();
      });
    });
  }

  init() {
    this.summary.addEventListener("click", (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.content.style.overflow = "hidden";

    if (this.isClosing || !this.details.open) {
      this.closeOtherAccordions();
      this.open();
    } else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  }

  closeOtherAccordions() {
    document.querySelectorAll("details-animated details[open]").forEach((openDetail) => {
      if (openDetail !== this.details) {
        openDetail.removeAttribute("open");
      }
    });
  }

  shrink() {
    this.isClosing = true;

    if (this.slideAnimation) this.slideAnimation.cancel();

    this.details.setAttribute("data-animating", "false");

    this.content.style.willChange = "transform";
    this.slideAnimation = this.content.animate(
      [
        { transform: "translateX(0%)" },
        { transform: "translateX(-100%)" }
      ],
      { duration: 400, easing: "ease", fill: "forwards" }
    );

    this.slideAnimation.onfinish = () => this.onAnimationFinish(false);
    this.slideAnimation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.details.open = true;
    window.requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    this.details.setAttribute("data-animating", "true");
    const searchmobile = document.querySelector('.header__search-wrapper .header__search');
    searchmobile.close();

    if (this.slideAnimation) this.slideAnimation.cancel();

    this.content.style.willChange = "transform";
    this.slideAnimation = this.content.animate(
      [
        { transform: "translateX(-100%)" },
        { transform: "translateX(0%)" }
      ],
      { duration: 400, easing: "ease-out", fill: "forwards" }
    );

    this.slideAnimation.onfinish = () => this.onAnimationFinish(true);
    this.slideAnimation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.details.open = open;
    if (this.slideAnimation) {
      try { this.slideAnimation.cancel(); } catch (e) {}
      this.slideAnimation = null;
    }

    this.isClosing = false;
    this.isExpanding = false;
    this.content.style.transform = "";
    this.content.style.overflow = "";
    this.content.style.willChange = "";

    if (!open && this.midLevelMenu.length) {
      this.midLevelMenu.forEach(el => el.classList.remove("active"));
    }

    if (!open && this.lastlevelMenu) {
      this.lastlevelMenu.removeAttribute("open");
    }
  }
}

customElements.define("details-animated", DetailsAnimated);




class MobileMegamenu extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const megamenuMainItem = this.querySelectorAll(".megamenu-mobile-main-item");
    const MenuListItem = this.querySelectorAll(".mobile-menu-drawer__content");
    const backButton = this.querySelectorAll(".main-menu__back-button");
    const innerDrawer = this.querySelectorAll("last-level-detail-menu details");
      backButton.forEach(button => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          MenuListItem.forEach(el => {
            el.classList.remove("active");
          });
          innerDrawer.forEach(el => {
            el.removeAttribute("open");
          })
        });
      });

    
    megamenuMainItem.forEach(item => {
      let has_menu = false;
      MenuListItem.forEach(menu => {
          const menuId = item.getAttribute("data-mobile-menu-id");
          const itemId = menu.getAttribute("data-mobile-item-id");
          if (menuId === itemId) {
            has_menu = true;
            item.classList.add("has_drawer");
          }
        });
      if (has_menu == true){
        item.addEventListener("click", (e) => {
          e.preventDefault();
          const menuId = e.currentTarget.getAttribute("data-mobile-menu-id");
          const previousMenu = document.querySelector(".main-menu__back-button");
          const prevTitle = previousMenu.textContent.slice(0, -1);
          
          MenuListItem.forEach(menu => {
            menu.classList.remove("active");
          });

          MenuListItem.forEach(menu => {
            const itemId = menu.getAttribute("data-mobile-item-id");
            if (menuId === itemId) {
              menu.classList.add("active");
              const mainMenuTitle = item.querySelector(".main_title").textContent.trim();              
              const titleClass = menu.querySelectorAll(".main__title");
              const titleClassLastChild = menu.querySelectorAll(".inner__title");
              const menuPrevTitle = menu.querySelectorAll(".menu-prev__title");
              const menuPrevTitleSecond = menu.querySelectorAll(".menu-prev__title-second");
              titleClass.forEach(title => {
                title.innerHTML = mainMenuTitle;
              });
              menuPrevTitle.forEach(title => {
                title.innerHTML = mainMenuTitle;
              });
              menuPrevTitleSecond.forEach(title => {
                title.innerHTML = prevTitle;
              });
              if (titleClassLastChild){
                titleClassLastChild.forEach(title => {
                  title.innerHTML = mainMenuTitle;
                });
              }
            }
          });
        });
      }
    });
  } 
}
customElements.define('mobile-megamenu', MobileMegamenu);



class LastLevelMenu extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('.menu-lastlevel-child');
  

    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    const inner_back_buttons = this.querySelectorAll(".inner-menu__back-button");

    inner_back_buttons.forEach(button => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        this.closeOtherAccordions();
        this.shrink(); 
      });
    });



    // Ensure transform origin is set
    this.content.style.transformOrigin = "right";

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200
    });
  }

  init() {
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.content.style.overflow = 'hidden';

    if (this.isClosing || !this.details.open) {
      this.closeOtherAccordions();
      this.open();
    }
    else if (this.isExpanding || this.details.open) {
      this.shrink();
    }
  }


  closeOtherAccordions() {
    document.querySelectorAll('last-level-detail-menu details[open]').forEach((openDetail) => {
      if (openDetail !== this.details) {
        openDetail.removeAttribute('open');
      }
    });
  }

  shrink() {
    this.isClosing = true;

    if (this.animation) this.animation.cancel();

    this.animation = this.content.animate({
      transform: ["translateX(0)", "translateX(100%)"]
    }, {
      duration: 400,
      easing: "ease"
    });

    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => this.isClosing = false;
  }

  open() {
    this.details.open = true;
    window.requestAnimationFrame(() => this.expand());
    this.perentWrapper = this.closest(".mobile-menu-drawer__content.active");
    this.content.style.top = this.perentWrapper.scrollTop + "px";

  }

  expand() {
    this.isExpanding = true;

    if (this.animation) this.animation.cancel();

    this.animation = this.content.animate({
      transform: ["translateX(100%)", "translateX(0)"]
    }, {
      duration: 400,
      easing: "ease-out"
    });

    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => this.isExpanding = false;
  }

  onAnimationFinish(open) {
    this.details.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;

    // Reset inline styles
    this.content.style.transform = open ? "translateX(0)" : "";
    this.content.style.height = this.content.style.overflow = '';
  }
}
customElements.define('last-level-detail-menu', LastLevelMenu);

class MenuImageCarousel extends HTMLElement{
  constructor(){
    super();
    const imageCarousel = document.querySelector('.js-image-carousel');
    if (!imageCarousel) return;
    const swiper = new Swiper('.js-image-carousel', {
      slidesPerView: "auto",
      a11y: "true",
    });

  }

}
customElements.define('menu-image-carousel', MenuImageCarousel);